import React from 'react';
import { Pane, Text } from '@leverege/ui-elements';

// TODO: stolen from recovr-server
import { jsx as _jsx } from "react/jsx-runtime";
const SALE_STATES = {
  PENDING: 'pending',
  SOLD: 'sold',
  VOID: 'void'
};
const VARIANTS = {
  [SALE_STATES.PENDING]: 'pillWarning|pill',
  [SALE_STATES.SOLD]: 'pillSuccess|pill',
  [SALE_STATES.VOID]: 'pillPrimary|pillBlue|pill'
};
const LABELS = {
  [SALE_STATES.PENDING]: 'Pending',
  [SALE_STATES.SOLD]: 'Complete',
  [SALE_STATES.VOID]: 'Void'
};
export default function SaleState(props) {
  const {
    value,
    defaultValue = '---'
  } = props;
  if (typeof value !== 'string' || !value) {
    return defaultValue;
  }
  return /*#__PURE__*/_jsx(Pane, {
    variant: "tableCellContent",
    children: /*#__PURE__*/_jsx(Text, {
      variant: VARIANTS[value] || 'pill',
      children: LABELS[value] || value
    })
  });
}